import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import React from "react";

const iconStyles = {
  fontSize: 20,
  marginInlineEnd: 8,
};

export const snackbarNotificationIconVariant = {
  info: <InfoIcon style={iconStyles} />,
  success: <CheckCircleIcon style={iconStyles} />,
  warning: <WarningIcon style={iconStyles} />,
  error: <ErrorIcon style={iconStyles} />,
};
